import { createActions, createState, createReducer } from 'reduxsauce-crud'

const d = { deep: true }

export const ContractsRedux = createActions(
  {
    getContractsRequest: ['parentId'],
    getContractsSuccess: ['contracts'],
    getContractsError: ['err'],
    getContractsByCompanyIdRequest: ['companyId'],
    getContractsByCompanyIdSuccess: ['contracts'],
    getContractsByCompanyIdError: ['error'],
  },
  {
    prefix: 'CONTRACTS_',
    defaultActions: {},
  },
)

const { Types, Creators } = ContractsRedux
export const ContractsTypes = Types
export default Creators

export const INITIAL_STATE = createState({
  company_contracts: {
    fetching: false,
    results: [],
    errors: null,
  }
},
{
  fetching: false,
  results: [],
  errors: null,
})

const getContractsRequest = state => state.merge({ fetching: true }, d)
const getContractsSuccess = (state, { contracts }) =>
  state.merge({ fetching: false, results: contracts, errors: null }, d)
const getContractsError = (state, { err }) =>
  state.merge({ fetching: false, results: [], errors: err }, d)

const getContractsByCompanyIdRequest = state =>
  state.merge({ company_contracts: { fetching: true, error: null } }, d)
const getContractsByCompanyIdSuccess = (state, { contracts }) =>
  state.merge({ company_contracts: { fetching: false, results: contracts, errors: null } }, d)
const getContractsByCompanyIdError = (state, { err }) =>
  state.merge({ company_contracts: { fetching: false, results: [], errors: err } }, d)

export const reducer = createReducer(INITIAL_STATE, {
  [Types.getContractsRequest]: getContractsRequest,
  [Types.getContractsSuccess]: getContractsSuccess,
  [Types.getContractsError]: getContractsError,
  [Types.getContractsByCompanyIdRequest]: getContractsByCompanyIdRequest,
  [Types.getContractsByCompanyIdSuccess]: getContractsByCompanyIdSuccess,
  [Types.getContractsByCompanyIdError]: getContractsByCompanyIdError,
},
{
  defaultActions: {},
  Types,
})



// WEBPACK FOOTER //
// ./src/Data/Redux/ContractsRedux.js